import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Contract } from "@edp-components/edp-contract";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import momentBusiness from "moment-business-days";
import moment from "moment-business-days";
import { RequestDateValidator } from "@edp-validators/request-date.validator";


@Component({
    selector: "end-contract",
    templateUrl: "./end-contract.component.html",
    styleUrls: ["./end-contract.component.scss"]
})

export class EndContractComponent implements OnInit {
    @Input() request: any;
    @Input() selectedContract: Contract;
    @Output() submitData = new EventEmitter();

    public form: FormGroup;
    public hours = [
        {
            value: "8h00 - 10h30",
            selected: false,
            text: "8h00 - 10h30",
        },
        {
            value: "10h30 - 13h00",
            selected: false,
            text: "10h30 - 13h00",
        },
        {
            value: "13h00 - 15h30",
            selected: false,
            text: "13h00 - 15h30",
        },
        {
            value: "15h30 - 18h00",
            selected: false,
            text: "15h30 - 18h00",
        },
    ];
    public types = [
        {
            id: 1,
            type: "E",
            selected: false
        },
        {
            id: 2,
            type: "G",
            selected: false
        },
        {
            id: 3,
            type: "DUAL",
            selected: false
        }
    ];

    constructor(
        private fb: FormBuilder,
        private store: Store<IAppState>,
    ) {
        this.form = this.fb.group({
            period: new FormControl(null, Validators.required),
            date: new FormControl(null, [Validators.required, RequestDateValidator]),
            type: new FormControl(null)
        });

        this.form.valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(() => {
            this.submitData.emit(!!this.form.valid ? this.form.value : null);
        });
    }

    ngOnInit() {
        if (!!this.selectedContract.HasE && !!this.selectedContract.HasG) {
            this.form.get("type").setValidators(Validators.required);
            this.form.updateValueAndValidity();
        }
    }

    public setPeriod(event) {
        this.hours.forEach(el => {el.selected = el.value === event.value
            ? true
            : false;
        });

        this.form.get("period").setValue(event.value);
    }

    public setTypeDelete(id, type) {
        this.types.map(el => { el.selected = el.id === id ? !el.selected : false; });

        this.form.get("type").setValue(!!this.types.find(el => el.selected) ? type : null);
    }

    get type() {
        return this.form.get("type").value;
    }

}
